import { useState, useEffect } from "react";

export default function SubscribeComponent(){
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [showMessage, setShowMessage] = useState(false);

    const postSubscriptionEmail = async( name, email ) => {
        try {
            const response = await fetch("https://imajin.dev/api/create-a-page-subscription-email", {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    name,
                    email
                }),
            });
        
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
        
            console.log("Comment posted successfully");
        } catch (error) {
        console.error("Error posting comment:", error.message);
        }
    }

    const handleSubmit = () => {
        if (!name || !email) {
          alert("Both fields are required");
          return;
        }

        postSubscriptionEmail(name, email);

        setName("");
        setEmail("");

        //TOAST MESSAGE
        setShowMessage(true);
        setTimeout(() => {
          setShowMessage(false);
        }, 3000);

    };

    return(
        <div style = { { backgroundColor : "var(--black2)", padding : "64px", display : "flex", flexDirection : "column", alignItems : "center", width : "100%", marginBottom : "40px", paddingBottom : "72 bpx", borderBottom : "solid var(--white16) 1px" } }>
            <p style = { { padding : "16px"} }>Stay in touch for updates on my tutorials, workshops, and videos</p>
            
            <div style = { { display: "flex", gap: "8px", height: "40px" } }>
                <input 
                    value = { name }
                    onChange = { (e) => setName(e.target.value) }
                    type="text" 
                    placeholder="Name" 
                    style={{ 
                    flex: "1", 
                    height: "100%", 
                    boxSizing: "border-box",
                    padding: "8px",
                    border: "1px solid #ccc"
                    }} 
                />
                <input 
                    value = { email }
                    onChange = { (e) => setEmail(e.target.value) }
                    type="text" 
                    placeholder="Email" 
                    style={{ 
                    flex: "2", 
                    height: "100%", 
                    boxSizing: "border-box",
                    padding: "8px",
                    border: "1px solid #ccc"
                    }} 
                />
                <button onClick = { handleSubmit }
                    style={{ 
                    flex: "1", 
                    height: "100%", /* Match parent's height */
                    boxSizing: "border-box", 
                    '--hover-color' : "rgba(0, 0, 255, 1)"
                    }} 
                    className = "navLink"
                >
                    Subscribe
                </button>
            </div>

            { showMessage && <p style = { { marginTop : "24px" } }>Thank you for your subscription. Please check your email!</p> }
            
        </div>
    )
}